// React import
import React from "react";
import { bindActionCreators } from "redux";
import { setPage } from "../../actions";
import { connect } from "react-redux";
// Imports components
import TonWalletButton from "../TonWalletButton";
// Import styles
import "./UserArea.css";
// Import consts
import { PAGE_UPGRADE } from "../../consts/consts";

class UserArea extends React.Component {

    formatNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    formatDate(timestamp) {
        if (!timestamp) return "Invalid date";

        const date = new Date(parseInt(timestamp) * 1000);
        const options = { year: "numeric", month: "short", day: "numeric" };
        return date.toLocaleDateString(undefined, options);
    }

    handleClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_UPGRADE);
    };

    render() {
        const {
            ai_energy,
            ai_level,
            subscription,
            subscription_expires,
            num_of_check_wallet_req,
            num_of_token_analyzer_req,
        } = this.props.userData;

        const expiryDate = subscription === "free" ? "unlimited" : this.formatDate(subscription_expires);

        return (
            <div className="user-area noselect">
                <img src={this.props.userData.photo_url} alt="User Icon" className="user-area-icon" />
                <span className="user-area-text">{this.props.userData.username}</span>

                <div className="user-area__stats-block noselect">
                    <div className="user-area__stats">
                        {[
                            { label: "AI level", value: ai_level },
                            { label: "AI energy", value: this.formatNumber(ai_energy) },
                            { label: "Subscription", value: subscription },
                            { label: "Subscription expires", value: expiryDate },
                            { label: "Check wallet", value: this.formatNumber(num_of_check_wallet_req) },
                            { label: "Token analyzer", value: this.formatNumber(num_of_token_analyzer_req) },
                        ].map((item, index) => (
                            <div className="user-area__stats-item" key={index}>
                                <span className="user-area__stats-text">{item.label}</span>
                                <span className="user-area__stats-text">{item.value}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="user-area__buttons">

                    <div className="user-area__button" onClick={this.handleClick}>
                        <span className="user-area__button-text">Upgrade</span>
                    </div>
                    <TonWalletButton/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({page, userData}) => ({page, userData });

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setPage,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UserArea);
